module.exports = __webpack_public_path__ + "static/img/weather-bg-3.2be20af.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-3.gif
// module id = 4RwX
// module chunks = 1